import { Outlet, ScrollRestoration } from 'react-router-dom';
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';

function MainLayout() {
    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1" id="main-content">
                <Outlet />
            </main>
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default MainLayout;
